import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The hover controls of a column: the pencil, and a menu with duplicate and
 * delete on it. Split out of `web-item-controls` for the reason the blocks were
 * — a column neither reorders nor goes to the gallery, and it is the only entity
 * that explains a locked delete in a tooltip.
 */
@Component({
    selector: 'web-default-column-controls',
    templateUrl: './default-column-controls.component.html',
    styleUrls: ['./default-column-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class DefaultColumnControlsComponent {
    /**
     * The last column of a section, one holding the cart widget, or one the
     * plan's product limit locks — see the column's own template for which.
     */
    public readonly disableCopyEvent = input<boolean>(false);
    public readonly disableRemoveEvent = input<boolean>(false);

    public readonly selectActionTooltip = input<string>('');

    /** Why deleting is locked, shown on the entry itself. */
    public readonly disableRemoveEventTooltip = input<string>('');

    public readonly selectEvent = output<void>();
    public readonly copyEvent = output<void>();
    public readonly deleteEvent = output<void>();
    public readonly toggleMoreActionState = output<boolean>();

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public copyAction(): void {
        if (this.disableCopyEvent()) {
            return;
        }

        this.copyEvent.emit();
    }

    public deleteAction(): void {
        if (this.disableRemoveEvent()) {
            return;
        }

        this.deleteEvent.emit();
    }

    public isShowDropDownMenu(state: boolean): void {
        this.toggleMoreActionState.emit(state);
    }
}
